<template>
  <div class="import-trackers-con d-flex justify-content-center align-items-center flex-column p-6">
    <div class="d-inline-block">
      <p><b>You can add the tracker combination by uploading the tracker spreadsheet</b></p>
      <b-form-group
        class="text-center"
      >
        <b-form-checkbox
          :checked="isImportingPlacementLevelTrackers"
          @change="toggleImportingPlacementLevelTrackers($event)"
          data-test="placement-level-trackers"
          name="check-button"
          size="sm"
          switch
        >
          check here if trackers are placement level
        </b-form-checkbox>
      </b-form-group>
      <p />
      <div class="combination-splits">
        <p class="text-center">
          Select tracker split
        </p>
        <div class="combination-splits-con">
          <b-form-checkbox
            :value="true"
            :unchecked-value="false"
            :checked="combinationSplit.size"
            data-test="tracker-size-split"
            name="check-button"
            variant="secondary"
            size="sm"
            @input="onUpdateSplitCheckbox('size', $event)"
          >
            Size
          </b-form-checkbox>
          <b-form-checkbox
            :value="true"
            :unchecked-value="false"
            :checked="combinationSplit.publisher"
            data-test="tracker-publisher-split"
            name="check-button"
            variant="secondary"
            size="sm"
            @input="onUpdateSplitCheckbox('publisher', $event)"
          >
            Publisher
          </b-form-checkbox>
          <b-form-checkbox
            :value="true"
            :unchecked-value="false"
            :checked="combinationSplit.geo"
            data-test="tracker-geo-split"
            name="check-button"
            variant="secondary"
            size="sm"
            @input="onUpdateSplitCheckbox('geo', $event)"
          >
            Geo
          </b-form-checkbox>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <b-form
        class="mb-6"
      >
        <b-form-group
          class="mt-6"
          label="Choose a file to upload (.xls)"
          label-for="trackerFile"
          :invalid-feedback="'Please use an excel file (.xls or .xlsx).'"
          :state="isFileValid"
        >
          <b-form-file
            id="trackerFile"
            data-test="trackers-file-input"
            :accept="acceptedTypes.join()"
            @input="onFileUpload"
            :state="isFileValid"
            v-model="file"
            class="is-draggable"
          />
        </b-form-group>
      </b-form>
    </div>
    <div
      v-if="loading"
      class="loading"
    >
      <div class="loading-con">
        <span>Loading...</span>
        <b-spinner variant="primary" />
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';
import * as trackersTypes from '@/modules/trackers/store/types';

export default {
  name: 'ImportTracker',
  components: {
  },
  data() {
    return {
      loading: false,
      file: [],
    };
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
    ]),
    ...mapState('trackers', [
      'isImportingPlacementLevelTrackers',
      'combinationSplit',
    ]),
    acceptedTypes() {
      return [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
      ];
    },
    isFileValid() {
      return !this.file.type || this.acceptedTypes.includes(this.file.type);
    },
  },
  methods: {
    ...mapActions('trackers', [
      trackersTypes.PARSE_TRACKERS_FILE,
      trackersTypes.SET_IMPORTING_PLACEMENT_LEVEL_TRACKERS,
    ]),
    ...mapMutations('trackers', [
      trackersTypes.SET_COMBINATION_SPLIT,
    ]),
    toggleImportingPlacementLevelTrackers(isPlacement) {
      this.SET_IMPORTING_PLACEMENT_LEVEL_TRACKERS(isPlacement);
    },
    onUpdateSplitCheckbox(prop, value) {
      const combinationSplit = { ...this.combinationSplit };
      combinationSplit[prop] = value;
      this.SET_COMBINATION_SPLIT(combinationSplit);
    },
    async onFileUpload(file) {
      if (!this.isFileValid || !file) return;
      this.loading = true;
      this.$emit('block-cancel-btn', true);
      try {
        await this.PARSE_TRACKERS_FILE({ file, campaignId: this.campaign.id });
        this.loading = false;
        this.$emit('enable-next-step');
      } catch (e) {
        this.$emit('block-cancel-btn', false);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.import-trackers-con {
  max-height: 60vh;
}
::v-deep {
  .combination-splits {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    p { width: 100%; }
    .combination-splits-con {
      display: flex;
      justify-content: space-between;
      width: 200px;
    }
  }
  .loading, .loading-con {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 0.75rem
    }
  }
}
</style>

<style lang="scss">
$radio-size: 1.2rem;

.import-trackers {
  &__radio {
    .custom-control-label {
      &::before {
        width: $radio-size;
        height: $radio-size;
      }

      &::after {
        width: $radio-size;
        height: $radio-size;
      }
    }
  }
}
</style>
